import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { supabase } from "@/lib/supabase/client";

export function AdminRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const [checkingAdmin, setCheckingAdmin] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    let cancelled = false;

    async function check() {
      if (!user) {
        setCheckingAdmin(false);
        setIsAdmin(false);
        return;
      }

      setCheckingAdmin(true);
      try {
        const { data, error } = await supabase
          .from("profiles")
          .select("metadata")
          .eq("id", user.id)
          .single();
        if (error) throw error;
        if (!cancelled) {
          setIsAdmin(!!data?.metadata?.is_admin);
        }
      } catch {
        if (!cancelled) {
          setIsAdmin(false);
        }
      } finally {
        if (!cancelled) {
          setCheckingAdmin(false);
        }
      }
    }

    if (!loading) {
      check();
    }

    return () => {
      cancelled = true;
    };
  }, [user, loading]);

  if (loading || checkingAdmin) {
    return <div className="min-h-screen bg-background text-foreground p-4">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/" />;
  }

  if (!isAdmin) {
    return <Navigate to="/dashboard" />;
  }

  return <>{children}</>;
}

